import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const TopNav = ({ deviceId, currentPath }) => {
  const [cartCount, setCartCount] = useState(0);
  const [logoTaps, setLogoTaps] = useState(0);
  const [lastTapTime, setLastTapTime] = useState(0);

  useEffect(() => {
    loadCartCount();
  }, [deviceId]);

  const loadCartCount = async () => {
    try {
      if (deviceId) {
        const cart = await api.getCart(deviceId);
        const count = cart.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;
        setCartCount(count);
      }
    } catch (error) {
      console.error('Error loading cart count:', error);
    }
  };

  const handleLogoClick = () => {
    const now = Date.now();
    if (now - lastTapTime < 500) {
      setLogoTaps(prev => prev + 1);
    } else {
      setLogoTaps(1);
    }
    setLastTapTime(now);

    if (logoTaps >= 2) {
      window.location.href = '/admin';
    }
  };

  const isActive = (path) => currentPath === path;

  return (
    <div className="top-nav">
      <div className="top-nav-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img src="/logo.png" alt="The Loop" style={{ imageRendering: 'pixelated' }} />
        <span className="top-nav-brand">THE LOOP</span>
      </div>
      
      <div className="top-nav-links">
        <Link to="/" className={`top-nav-link ${isActive('/') ? 'active' : ''}`}>SHOP</Link>
        <Link to="/lookbook" className={`top-nav-link ${isActive('/lookbook') ? 'active' : ''}`}>LOOKBOOK</Link>
        <Link to="/rewards" className={`top-nav-link ${isActive('/rewards') ? 'active' : ''}`}>REWARDS</Link>
      </div>
      
      <div className="top-nav-actions">
        <Link to="/cart" className="cart-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </Link>
        
        <Link to="/profile" style={{ color: '#FEFEE3' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default TopNav;
